import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SearchReportQuery } from '../../../../models/search-report-query.model';
import { SearchReportService } from '../../../../services/search-report.service';
import { Group } from '../../../../models/group.model';
import { Router } from '@angular/router';
import { SearchReport, SearchReportStatus } from '../../../../models/search-report.model';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'lex-search-report-queries',
    templateUrl: './search-report-queries.component.html',
    styleUrls: ['./search-report-queries.component.scss'],
    standalone: false
})
export class SearchReportQueriesComponent implements  OnChanges {

  @Input() reportQueryDataSource: SearchReportQuery[];
  @Input() report: SearchReport;
  @Input() isGraphView: boolean;
  @Output() deletedQuery = new EventEmitter<SearchReportQuery>();

  editReportQueryId: string = '';
  displayColumns: string[] = ['query', 'hitCount', 'expandedHitCount', 'uniqueHitCount'];
  groups: Group[];
  graphHeight: number;
  
  private expandedHitCountTitle: string = 'Expanded Hit Count';
  private hitCountTitle: string = 'Hit Count';
  private uniqueHitCountTitle: string = 'Unique Hit Count';

  get ReportStatus(): typeof SearchReportStatus { return SearchReportStatus; }

  constructor(private searchReportService: SearchReportService,
    private router: Router,
    private snackbar: MatSnackBar) { }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.reportQueryDataSource || changes.isGraphView) && this.isGraphView && this.reportQueryDataSource) {
      this.groups = [];
      this.reportQueryDataSource.forEach(query => {
        this.groups.push({
          name: query.query,
          series: [
            { name: this.expandedHitCountTitle, value: query.expandedHitCount },
            { name: this.hitCountTitle, value: query.hitCount },
            { name: this.uniqueHitCountTitle, value: query.uniqueHitCount }
          ]
        });
      });

      // In order for every group to have the same height in the graph,
      // the overall graph height needs to be scaled based on the number of groups (i.e. queries)
      this.graphHeight = 65 * this.groups.length;
    }
  }

  updateReportQuery(reportQuery: SearchReportQuery) {
    if (reportQuery.query !== '')
      this.searchReportService.updateSearchReportQuery(reportQuery).subscribe(data => {
        if (!data.valid) {
          this.snackbar.open(`Query failed to save: ${reportQuery.query}`, 'X', {
            duration: 5000
          });
          reportQuery.query = data.query;
        }
      });
    else
      this.deleteReportQuery(reportQuery.searchReportQueryId);

    this.editReportQueryId = '';
  }

  deleteReportQuery(reportQueryId: string) {
    this.searchReportService.deleteSearchReportQuery(reportQueryId).subscribe(() => {
      this.deletedQuery.emit(this.reportQueryDataSource.find(q => q.searchReportQueryId == reportQueryId));
    });
  }

  select(evt) {
    const query = this.reportQueryDataSource.find(q => q.query === evt.series);
    if (!query) {
      console.warn('Could not find query');
      return;
    }
    // filtering for reports was enabled system wide on 2022-09-11. any reports run before will can not be filter on
    if (new Date(this.report.dateTimeRun) < new Date('2022-09-11 00:00:00.0000000'))
      return;

    if (evt.name === this.hitCountTitle)
      this.router.navigate(['/review/browse'], { queryParams: { SearchReportId: this.report.searchReportId, SearchReportQueryIds: query.searchReportQueryId } });
    else if (evt.name === this.uniqueHitCountTitle)
      this.router.navigate(['/review/browse'], { queryParams: { SearchReportId: this.report.searchReportId, SearchReportQueryIds: query.searchReportQueryId, UniqueSearchQuery: true } });
    else if (evt.name == this.expandedHitCountTitle)
      this.router.navigate(['/review/browse'], { queryParams: { SearchReportId: this.report.searchReportId, SearchReportQueryIds: query.searchReportQueryId, ExpandToEmailFamily: true } });
    else
      console.warn('Unkown event');
  }
}
